export const text = {
  TITLE: 'ICD-10 codes',
  NO_CODES: 'No ICD-10 codes',
  PLACEHOLDER: 'Search ICD-10',
}

export const styles = {
  SEARCH_RESULTS_HIDDEN: { maxHeight: 340 },
  DETAILS_HEIGHT: { maxHeight: 524 },
  DETAILS_NO_CODES_HEIGHT: { height: 100 },
  DETAILS_TOP_ERROR_STYLE: { top: 108 },
  READ_ONLY_LIST_HEIGHT_STYLE: { maxHeight: 227 },
}
